import { ChipNavigationMui, ChipNavigationProps } from '@mi-front/ui';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import { Alert, Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { ReportResultProps } from '../../../../../../../../core/reports/types';
import { UnverifiedLtxEntriesTable } from './components/UnverifiedLtxEntriesTable';
import { UnverifiedMatchesTable } from './components/UnverifiedMatchesTable';
import { VerifiedMatchesTable } from './components/VerifiedMatchesTable';
import { LtxMatchesReport } from './types';

export function LtxMatchesReportResult(p: ReportResultProps<LtxMatchesReport>) {
  const { $t } = useIntl();
  const { verified, unverifiedMatches, unverifiedLtxEntries, meta } = p.result;

  const chips: ChipNavigationProps['chips'] = [
    {
      value: 'verified',
      label: `${$t({
        id: 'audit.reportsScreen.ltxMatches.tabs.verified',
        defaultMessage: 'Matches verificados',
      })} (${verified.length})`,
      icon: <CheckIcon />,
      content: <VerifiedMatchesTable data={verified} />,
    },
    {
      value: 'unverified-matches',
      label: `${$t({
        id: 'audit.reportsScreen.ltxMatches.tabs.unverifiedMatches',
        defaultMessage: 'Matches sin verificar',
      })} (${unverifiedMatches.length})`,
      icon: <CloseIcon />,
      color: 'warning' as const,
      content: <UnverifiedMatchesTable data={unverifiedMatches} />,
    },
    {
      value: 'unverified-ltx-entries',
      label: `${$t({
        id: 'audit.reportsScreen.ltxMatches.tabs.unverifiedLtxEntries',
        defaultMessage: 'Entradas LTX sin verificar',
      })} (${unverifiedLtxEntries.length})`,
      icon: <WarningIcon />,
      color: 'warning' as const,
      content: <UnverifiedLtxEntriesTable data={unverifiedLtxEntries} />,
    },
  ];

  return (
    <Box>
      {meta?.missingLtxEntries && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {$t({
            id: 'audit.reports.ltxMatches.noLtxEntries',
            defaultMessage: 'No se encontraron entradas LTX para el reporte',
          })}
        </Alert>
      )}
      <ChipNavigationMui
        chips={chips}
        defaultActiveChip="verified"
        ContentWrapper={(p) => <Box mt={2} {...p} />}
      />
    </Box>
  );
}
